// Translations ES / EN for static UI strings
// Note: dynamic content (hero title, services, about...) lives in MongoDB and is
// shown as-is. Only UI labels and legal pages are translated here.

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Quiénes Somos',
      services: 'Servicios',
      pricing: 'Tarifas',
      works: 'Trabajos',
      contact: 'Contacto',
    },
    cta: {
      clientAccess: 'Acceso Clientes',
      quote: 'Solicitar Presupuesto Especial',
      viewServices: 'Ver Servicios',
      seeMore: 'Saber más',
      requestService: 'Solicitar este servicio',
      requestStudy: 'Solicitar estudio gratuito',
      submitForm: 'Solicitar Estudio de Costes Competitivos',
      sending: 'Enviando...',
      sent: 'Solicitud enviada',
      respondEmail: 'Responder por email',
    },
    sections: {
      impactNumbers: '· Cifras de Impacto',
      impactTitle: 'Una',
      impactTitleHighlight: 'década',
      impactTitleEnd: 'moviendo el cine español sin un solo estreno fallido.',
      division: '· División Operativa',
      divisionTitle: 'Dos vías de transporte.',
      divisionTitleHighlight: 'Una sola red.',
      divisionDescription:
        'Conectamos la nube con la logística terrestre clásica. Llegamos a la última sala del territorio nacional, conectada o no a banda ancha.',
      about: '· Quiénes Somos',
      ourMission: 'Nuestra Misión',
      ourPillars: 'Nuestros Pilares',
      services: '· Portafolio de Servicios',
      servicesTitle: 'Todo lo que necesitas para tu',
      servicesHighlight: 'estreno',
      servicesTitleEnd: ', bajo un mismo techo.',
      servicesCounter: '05 — Servicios',
      pricing: '· Modelo de Precios',
      pricingTitle: 'Soluciones de',
      pricingHighlight: 'alta competitividad',
      pricingTitleEnd: 'económica.',
      pricingDescription:
        'Ajustamos nuestros costes al tamaño de tu campaña de distribución. Ya lances una película en 5 salas de versión original o un estreno masivo en 400 pantallas, somos el carrier más competitivo del mercado.',
      pricingTableService: 'Servicio',
      pricingTableModality: 'Formato / Modalidad',
      pricingTableRate: 'Tarifa Base',
      pricingTableAction: 'Acción',
      pricingCustomBadge: 'Presupuesto a medida',
      pricingCustomTitle:
        '¿Lanzamiento de campaña nacional? Te preparamos un estudio de costes en menos de 24h.',
      works: '· Trabajos',
      worksTitle: 'Películas en las que hemos',
      worksHighlight: 'colaborado',
      worksDescription:
        'Una muestra de los estrenos nacionales que hemos llevado a las salas españolas en los últimos años.',
      worksReleases: 'Estrenos en salas',
      contact: '· Contacto Técnico',
      contactTitle: 'Cuéntanos tu',
      contactHighlight: 'campaña',
      contactTitleEnd: '. Te enviamos el estudio.',
      contactDescription:
        'Captación de leads cualificados para nuestro equipo comercial. Respondemos en menos de 24 horas hábiles.',
      contactEmailLabel: 'Email Comercial',
      contactPhoneLabel: 'Teléfono Directo',
      contactAddressLabel: 'Oficinas',
      contactHoursLabel: 'Horario',
      formDisclaimer:
        'Al enviar, aceptas el tratamiento de tus datos para el envío de la cotización comercial.',
      clientsTitle: '10 años al lado de las grandes',
      clientsHighlight: 'distribuidoras nacionales',
      clientsCounter: 'Distribuidoras activas',
    },
    form: {
      name: 'Nombre y Apellidos',
      position: 'Cargo',
      company: 'Distribuidora / Productora',
      email: 'Correo Corporativo',
      phone: 'Teléfono de Contacto',
      service: 'Tipo de Servicio Requerido',
      volume: 'Volumen Estimado de Salas',
      message: 'Mensaje / Especificaciones Técnicas',
      selectService: 'Selecciona un servicio',
      selectVolume: 'Selecciona volumen',
      placeholders: {
        name: 'María García',
        position: 'Directora de Distribución',
        company: 'Films Distribución S.L.',
        email: 'comercial@empresa.com',
        phone: '+34 600 000 000',
        message:
          'Cuéntanos los detalles técnicos del estreno, fechas, formatos...',
      },
      missingData: 'Faltan datos',
      missingDataDesc: 'Completa los campos obligatorios.',
      sendError: 'Error al enviar',
      sendErrorDesc: 'Inténtalo de nuevo en unos minutos.',
      sentDesc: 'Tu estudio de costes llegará en menos de 24 horas.',
    },
    footer: {
      rights: 'Todos los derechos reservados.',
      legal: 'Aviso Legal',
      privacy: 'Privacidad',
      cookies: 'Cookies',
      navigation: 'Navegación',
      contact: 'Contacto',
      description:
        'El carrier de confianza para las distribuidoras nacionales. Movemos el cine español desde 2014, conectando distribución y exhibición con la máxima seguridad criptográfica.',
    },
    hero: {
      techCompliance: ['DCI Compliant', 'SMPTE Standard', 'AES-128 Encryption', 'KDM Automation'],
      scroll: 'Scroll',
    },
    legal: {
      backToHome: '← Volver al inicio',
      legalTitle: 'Aviso Legal',
      privacyTitle: 'Política de Privacidad',
      cookiesTitle: 'Política de Cookies',
      lastUpdate: 'Última actualización',
      acceptAll: 'Aceptar todas',
      rejectAll: 'Rechazar todas',
      cookieSettings: 'Configurar',
      cookieBannerText:
        'Utilizamos cookies propias y de terceros para mejorar tu experiencia y analizar el tráfico de la web.',
    },
    common: {
      loading: 'Cargando...',
      error: 'No se pudo cargar el contenido.',
    },
    about: {
      established: 'Est. 2014 · Madrid',
      quote: '“En 10 años nunca hemos perdido un estreno de viernes.”',
      certified: 'Certificado',
    },
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      pricing: 'Pricing',
      works: 'Works',
      contact: 'Contact',
    },
    cta: {
      clientAccess: 'Client Access',
      quote: 'Request Special Quote',
      viewServices: 'View Services',
      seeMore: 'Learn more',
      requestService: 'Request this service',
      requestStudy: 'Request free assessment',
      submitForm: 'Request Competitive Cost Estimate',
      sending: 'Sending...',
      sent: 'Request sent',
      respondEmail: 'Reply by email',
    },
    sections: {
      impactNumbers: '· Impact Figures',
      impactTitle: 'A',
      impactTitleHighlight: 'decade',
      impactTitleEnd: 'moving Spanish cinema without a single failed release.',
      division: '· Operational Division',
      divisionTitle: 'Two delivery paths.',
      divisionTitleHighlight: 'One single network.',
      divisionDescription:
        'We connect the cloud with classic ground logistics. We reach the last screen in the country, connected to broadband or not.',
      about: '· About Us',
      ourMission: 'Our Mission',
      ourPillars: 'Our Pillars',
      services: '· Service Portfolio',
      servicesTitle: 'Everything you need for your',
      servicesHighlight: 'premiere',
      servicesTitleEnd: ', under one roof.',
      servicesCounter: '05 — Services',
      pricing: '· Pricing Model',
      pricingTitle: 'Solutions with',
      pricingHighlight: 'high cost competitiveness',
      pricingTitleEnd: '.',
      pricingDescription:
        'We adjust our costs to the size of your distribution campaign. Whether you launch a film in 5 OV screens or a massive premiere across 400 screens, we are the most competitive carrier in the market.',
      pricingTableService: 'Service',
      pricingTableModality: 'Format / Modality',
      pricingTableRate: 'Base Rate',
      pricingTableAction: 'Action',
      pricingCustomBadge: 'Custom quote',
      pricingCustomTitle:
        'Launching a national campaign? We will prepare a cost study in less than 24h.',
      works: '· Works',
      worksTitle: 'Films we have',
      worksHighlight: 'collaborated on',
      worksDescription:
        'A selection of national releases we have delivered to Spanish theaters in recent years.',
      worksReleases: 'Releases in theaters',
      contact: '· Technical Contact',
      contactTitle: 'Tell us about your',
      contactHighlight: 'campaign',
      contactTitleEnd: '. We will send you the study.',
      contactDescription:
        'Qualified lead capture for our sales team. We respond within 24 business hours.',
      contactEmailLabel: 'Sales Email',
      contactPhoneLabel: 'Direct Phone',
      contactAddressLabel: 'Offices',
      contactHoursLabel: 'Hours',
      formDisclaimer:
        'By submitting, you accept the processing of your data for sending the commercial quote.',
      clientsTitle: '10 years alongside Spain’s leading',
      clientsHighlight: 'national distributors',
      clientsCounter: 'Active distributors',
    },
    form: {
      name: 'Full Name',
      position: 'Position',
      company: 'Distributor / Producer',
      email: 'Corporate Email',
      phone: 'Contact Phone',
      service: 'Required Service Type',
      volume: 'Estimated Screen Volume',
      message: 'Message / Technical Specifications',
      selectService: 'Select a service',
      selectVolume: 'Select volume',
      placeholders: {
        name: 'Maria Smith',
        position: 'Distribution Director',
        company: 'Films Distribution Ltd.',
        email: 'sales@company.com',
        phone: '+34 600 000 000',
        message: 'Tell us the technical details of the release, dates, formats...',
      },
      missingData: 'Missing data',
      missingDataDesc: 'Please complete the required fields.',
      sendError: 'Send error',
      sendErrorDesc: 'Please try again in a few minutes.',
      sentDesc: 'Your cost study will arrive in less than 24 hours.',
    },
    footer: {
      rights: 'All rights reserved.',
      legal: 'Legal Notice',
      privacy: 'Privacy',
      cookies: 'Cookies',
      navigation: 'Navigation',
      contact: 'Contact',
      description:
        'The trusted carrier for national distributors. We have been moving Spanish cinema since 2014, connecting distribution and exhibition with maximum cryptographic security.',
    },
    hero: {
      techCompliance: ['DCI Compliant', 'SMPTE Standard', 'AES-128 Encryption', 'KDM Automation'],
      scroll: 'Scroll',
    },
    legal: {
      backToHome: '← Back to home',
      legalTitle: 'Legal Notice',
      privacyTitle: 'Privacy Policy',
      cookiesTitle: 'Cookie Policy',
      lastUpdate: 'Last update',
      acceptAll: 'Accept all',
      rejectAll: 'Reject all',
      cookieSettings: 'Settings',
      cookieBannerText:
        'We use our own and third-party cookies to improve your experience and analyze website traffic.',
    },
    common: {
      loading: 'Loading...',
      error: 'Content could not be loaded.',
    },
    about: {
      established: 'Est. 2014 · Madrid',
      quote: '“In 10 years we have never missed a Friday release.”',
      certified: 'Certified',
    },
  },
};

export default translations;
